import React, { useCallback } from 'react';
import classNames from 'classnames';
import { Field, FormSpy, useForm } from 'react-final-form';
import type { OptionValue } from 'ncoded-component-library/build/components/molecules/Select/Select.component';
import InputField from 'components/InputField/InputField.component';
import CountryPicker from 'components/CountryPicker';
import { ALL_COUNTRIES } from 'enums';
import './FieldPhoneNumber.styles.scss';

type FieldPhoneNumberProps = {
  name: string;
  label?: string;
  placeholder?: string;
  className?: string;
  suffixNode?: React.ReactNode;
  disabled?: boolean;
  required?: boolean;
};

const FieldPhoneNumber: React.FC<FieldPhoneNumberProps> = (props) => {
  const {
    name,
    label,
    placeholder,
    className,
    suffixNode,
    disabled,
    required,
  } = props;

  const { change } = useForm();

  const classes = classNames('field-phone-number', className);

  const onChange = useCallback(
    ({ value }: OptionValue<string | number>) => {
      const countryCode = ALL_COUNTRIES.find(
        ({ code: elCode }) => value.toString() === elCode,
      )?.call;

      change(`${name}.refferenceNumber`, countryCode);
    },
    [change, name],
  );

  return (
    <FormSpy
      subscription={{ values: true }}
      render={({ values }) => {
        const countryCodeValue = values?.[name]?.refferenceNumber || '+49';

        const defaultCountry = ALL_COUNTRIES.find(
          ({ call }) => call === countryCodeValue,
        );

        if (!values?.[name]?.refferenceNumber) {
          change(`${name}.refferenceNumber`, countryCodeValue);
        }

        return (
          <div className={classes}>
            {label && <label>{label}</label>}
            <Field name={`${name}.refferenceNumber`} component="input" hidden />
            <Field
              name={`${name}.number`}
              prefixNode={
                <CountryPicker
                  onChange={onChange}
                  defaultCountry={defaultCountry?.code}
                  displayValues={['name', 'call']}
                  searchValues={['call', 'name']}
                  disabled={disabled}
                  isPartOfPhoneField
                />
              }
              component={InputField}
              placeholder={placeholder}
              suffixNode={suffixNode}
              disabled={disabled}
              required={required}
            />
          </div>
        );
      }}
    />
  );
};

export default FieldPhoneNumber;
